import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../../_services/user.service';

@Component({
  selector: 'app-avatar-initials',
  templateUrl: './avatar-initials.component.html',
  styleUrls: ['./avatar-initials.component.scss'],
})
export class AvatarInitialsComponent implements OnInit {
  @Input()
  public photoUrl: string;

  @Input()
  public name: string;

  @Input()
  public defaultColor: boolean = false;

  @Input()
  public large: boolean = false;

  @Input()
  public small: boolean = false;

  @Input()
  public circleColor: string;

  @Input()
  public initialsColor: string;

  public showInitials = false;
  public initials: string;

  private colors = ['#1839B4'];

  constructor(private userService: UserService) {}

  ngOnInit() {
    if (!this.name) {
      let that = this;
      const user = this.userService.currentUser;
      if (user) {
        that.name = user.username;
        that.noPhotoUrlInit();
      }
    } else {
      if (!this.photoUrl) {
        this.noPhotoUrlInit();
      }
    }
  }

  noPhotoUrlInit() {
    this.showInitials = true;
    this.createInititals();
    if (this.circleColor) return null;

    if (this.defaultColor) {
      this.circleColor = this.colors[0];
    } else {
      const randomIndex = Math.floor(
        Math.random() * Math.floor(this.colors.length)
      );
      this.circleColor = this.colors[randomIndex];
    }
  }

  private createInititals(): void {
    let initials = '';
    let upperCaseName = this.name.toUpperCase().split('');
    initials = upperCaseName[0];

    for (let i = 0; i < upperCaseName.length; i++) {
      const element = upperCaseName[i];
      if (element === ' ') {
        initials += upperCaseName[i + 1];
        if (initials.length == 2) {
          break;
        }
      }
    }

    this.initials = initials;
  }
}
